import React, { Component, Fragment } from 'react'

class ImageAndText extends Component {
    renderContent() {
        const { data } = this.props
        const { setup } = data

        if (data.orientation === 'left') {
            return (
                <Fragment>
                    <div className={`col-md-${setup.imageColumnSize}`}>
                        <img src={data.image} className="img-responsive" alt="" style={{ width: '100%' }} />
                    </div>
                    <div className={`col-md-${setup.textColumnSize} offset-md-${setup.rightColumnOffset}`}>
                        <div className="row">
                            <div className="text-left">
                                {data.title && <h2 className="text-left lined" dangerouslySetInnerHTML={{ __html: data.title }}></h2>}
                            </div>
                            <div dangerouslySetInnerHTML={{ __html: data.text }}></div>
                        </div>
                    </div>
                </Fragment>
            )
        } else {
            return (
                <Fragment>
                    <div className={`col-md-${setup.textColumnSize}`}>
                        <div className="row">
                            <div className="text-right">
                                {data.title && <h2 className="text-right lined" dangerouslySetInnerHTML={{ __html: data.title }}></h2>}
                            </div>
                            <div dangerouslySetInnerHTML={{ __html: data.text }}></div>
                        </div>
                    </div>
                    <div className={`col-md-${setup.imageColumnSize} offset-md-${setup.rightColumnOffset}`}>
                        <img src={data.image} className="img-responsive" alt="" style={{ width: '100%' }} />
                    </div>
                </Fragment>
            )
        }
    }

    render() {
        const { css } = this.props
        
        return (
            <div className="container">
                <div className={`row ${css} align-items-center`}>
                    {this.renderContent()}
                </div>
            </div>
        )
    }
}

export { ImageAndText }


// WEBPACK FOOTER //
// ./src/components/sections/ImageAndText.js